import type { Maybe } from '@/helpers/types';

interface WithRetryOnErrorArgs {
	attempt: number;
	maxAttempts: number;
	error?: Error | undefined;
}

export async function withRetry<T>(
	cb: () => Promise<Maybe<T>>,
	onError: (args: WithRetryOnErrorArgs) => void | Promise<void>,
	{ maxAttempts = 3, delay = 100 } = {}
) {
	for (let attempt = 1; attempt <= maxAttempts; attempt++) {
		try {
			const result = await cb();
			if (result != null) return result;
			await onError({ attempt, maxAttempts });
		} catch (error: any) {
			await onError({ attempt, maxAttempts, error });
		}

		if (attempt < maxAttempts) {
			await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, attempt - 1)));
		}
	}
}
